// Import des balises meta
import { Helmet } from "react-helmet";
// Import du style
import './custom.scss';
// Import des routes
import { Routes, Route } from 'react-router-dom';
// Import des components
import Header from './components/header';
import Home from './components/home';
import Etudiant from './components/etudiant';
import Pro from "./components/pro";
import OwnedGames from "./functions/get_owned_games";
import Psn from "./functions/psn";

function App() {
  return (
    <div className="App" id="app">
      <Helmet>
        <meta property="og:title" content="Portfolio Mustafa Ekiz" />
        <meta property="og:description" content="Je suis Mustafa Ekiz, développeur web spécialisé sur WordPress et React je peux répondre à vos demandes sur différents projets" />
        <meta property="og:image" content={`${process.env.PUBLIC_URL}/og-image.png`} />
        <meta property="og:url" content={`${process.env.PUBLIC_URL}`} />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/psn" element={<Psn />} />
        <Route path="/etudiant" element={<Etudiant />} />
        <Route path="/pro" element={<Pro />} />
        <Route path="/games" element={<OwnedGames />} />
      </Routes>
    </div>
  );
}

export default App;
